export default __webpack_public_path__ + "static/media/thewatcherfreesyou.f3aee5a1.png";